import { useState } from 'react';
import { useScrollReveal } from '@/hooks/useScrollReveal';
import { faqData } from '@/mocks/faq';

export default function FAQ() {
  const [openId, setOpenId] = useState<string | null>('faq-1');
  const { ref, isVisible } = useScrollReveal();

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="w-full py-16 md:py-24 bg-ivory-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div
          ref={ref}
          className={`text-center mb-10 md:mb-14 ${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`}
        >
          <span className="inline-block text-xs md:text-sm font-semibold text-brand-orange uppercase tracking-widest mb-3">
            Got Questions?
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-charcoal-300">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3 md:gap-4">
          {faqData.map((item, index) => (
            <div
              key={item.id}
              className={`bg-white rounded-xl md:rounded-2xl shadow-sm overflow-hidden transition-all duration-300 hover:shadow-md ${
                isVisible ? 'animate-fade-in-up' : 'opacity-0'
              }`}
              style={{ animationDelay: `${0.08 + index * 0.06}s` }}
            >
              <button
                onClick={() => toggle(item.id)}
                className="w-full flex items-center justify-between p-4 md:p-6 text-left group"
              >
                <span className="text-sm md:text-base font-semibold text-charcoal-300 pr-4 group-hover:text-brand-orange transition-colors">
                  {item.question}
                </span>
                <span
                  className={`w-8 h-8 flex items-center justify-center rounded-full bg-brand-orange/10 text-brand-orange shrink-0 transition-transform duration-300 ${
                    openId === item.id ? 'rotate-45 bg-brand-orange text-white' : ''
                  }`}
                >
                  <i className={`${openId === item.id ? 'ri-close-line' : 'ri-add-line'} text-lg`} />
                </span>
              </button>
              <div
                className="overflow-hidden transition-all duration-400"
                style={{
                  maxHeight: openId === item.id ? '300px' : '0px',
                  opacity: openId === item.id ? 1 : 0,
                }}
              >
                <div className="px-4 md:px-6 pb-4 md:pb-6 text-sm md:text-base text-charcoal-50 leading-relaxed">
                  {item.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}